
const useFunctions = () => {

    return {
        toCamelCase: (str) => {
            str = str.replace(/\w+/g, function(w){return w[0].toUpperCase() + w.slice(1).toLowerCase();});
            return str;
        },
        ValidateEmail: (text) => {
            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (text.match(validRegex)) {
                return true;
            } else {
                return false;
            }
        },
        addDays: (date, days) => {
            let result = new Date(date)
            result.setDate(result.getDate() + days)
            return result
        },
        deleteDifferenceTimezone: (date) => {
            return new Date(date.setMinutes(date.getMinutes() + date.getTimezoneOffset()))
        }
    }

}

export default useFunctions